// extracted by mini-css-extract-plugin
export default {"container":"TermsAndConditions_container__rPBEL","text":"TermsAndConditions_text__W8nP0"};